import React from 'react';
import {LegacyRegulationWrapper} from "../legacy-regulation-wrapper";
import {
    IExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/external-links-handlers-factory.interface";
import {
    ItalyExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/regulations/italy/italy.external-links-handlers-factory";
import {IRegulationComponents} from "../regulation-components.interface";
import {ItalyRegulationComponents} from "./components/italy.regulation-components";
import {
    IRegulationMenuItemFactory
} from "../../menu-items-common/regulations-specific/regulation-menu-item-factory.interface";
import {ItalyMenuItemFactory} from "../../menu-item-regulation-specific/italy/italy.menu-item-factory";
import {
    InactivityTimeoutSettingsComponent
} from "../../../components/inactivity-timeout-settings/inactivity-timeout-settings.component";
import {GameInfo} from "../../games/game-info";
import {ITALY_MAX_GAME_LIMIT_AMOUNT_IN_CENTS} from "./italy-regulation-constants";



export class ItalyRegulation extends LegacyRegulationWrapper {
    get externalLinks(): IExternalLinksHandlersFactory {
        return new ItalyExternalLinksHandlersFactory(this.services);
    }

    get components(): IRegulationComponents {
        return new ItalyRegulationComponents(this.services);
    }

    get menuItems(): IRegulationMenuItemFactory {
        return new ItalyMenuItemFactory(this.services);
    }

    openInactivitySettings(): void {
        const analyticsCategory = 'italy_inactivity_window';

        this.services.analytics.sendAnalytics(analyticsCategory, 'open');

        this.services.dialog.showModal((dialogHandler) => {
            return (
                <InactivityTimeoutSettingsComponent dialogHandler={dialogHandler} analyticsCategory={analyticsCategory}/>
        );
        }, {
            title: this.services.translation.translate('INACTIVITY_TIMEOUT_SETTINGS_TITLE'),
            mobileCenterHeader: true,
            disableFullscreenMobile: true,
            forceCentralization: true,
            onClosedByXButton: () => {
                this.services.analytics.sendAnalytics(analyticsCategory, 'closed');
            }
        })
    }

    computeGameMaxLimitInCents(gameInfo: GameInfo): number {
        return Math.min(ITALY_MAX_GAME_LIMIT_AMOUNT_IN_CENTS, this.services.walletProxy.computeGameMaxLimit(gameInfo));
    }

    computeGameMinLimitInCents(gameInfo: GameInfo): number {
        return 100;
    }
}